module.exports = [
  {
    alocacao_percentual: 0.25,

    classe: 'Multimercado',

    data_atualizacao: 'Wed, 20 Oct 2021 22:50:10 GMT',

    data_registro: 'Wed, 20 Oct 2021 22:50:10 GMT',

    id: 29,

    id_ativo: 125235,

    id_ativo_composicao: 127226,

    id_escritorio: 83,

    nome_ativo: 'teste-1b8733bd-6d56-495e-85fc-cb309f6df8f7',

    subclasse: null,

    tipo: 'Fundos',
  },

  {
    alocacao_percentual: 0.25,

    classe: 'Multimercado',

    data_atualizacao: 'Wed, 20 Oct 2021 22:50:10 GMT',

    data_registro: 'Wed, 20 Oct 2021 22:50:10 GMT',

    id: 30,

    id_ativo: 125235,

    id_ativo_composicao: 127227,

    id_escritorio: 83,

    nome_ativo: 'teste-3f7741e1-3971-49d1-9a34-3860529669c9',

    subclasse: null,

    tipo: 'Fundos',
  },

  {
    alocacao_percentual: 0.25,

    classe: 'Multimercado',

    data_atualizacao: 'Wed, 20 Oct 2021 22:50:10 GMT',

    data_registro: 'Wed, 20 Oct 2021 22:50:10 GMT',

    id: 31,

    id_ativo: 125235,

    id_ativo_composicao: 136835,

    id_escritorio: 83,

    nome_ativo: 'teste-9b51e9c9-7274-4a6f-9c95-26fd99d5cb18',

    subclasse: null,

    tipo: 'Fundos',
  },

  {
    alocacao_percentual: 0.25,

    classe: 'Multimercado',

    data_atualizacao: 'Wed, 20 Oct 2021 22:50:10 GMT',

    data_registro: 'Wed, 20 Oct 2021 22:50:10 GMT',

    id: 32,

    id_ativo: 125235,

    id_ativo_composicao: 136836,

    id_escritorio: 83,

    nome_ativo: 'teste-c522e9b8-a768-4f13-83bf-d6a8a89c1959',

    subclasse: null,

    tipo: 'Fundos',
  },
]
